import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fail",
  "use": "fail-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"fail\"><path d=\"M7.89 7.293l2.828-2.829a.5.5 0 01.707.708L8.596 8l2.829 2.828a.5.5 0 01-.707.708L7.889 8.707l-2.828 2.829a.5.5 0 11-.707-.708L7.182 8 4.354 5.172a.5.5 0 01.707-.708l2.828 2.829zM8 0a8 8 0 110 16A8 8 0 018 0zm0 1.067a6.933 6.933 0 100 13.866A6.933 6.933 0 008 1.067z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol